import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import pageheader from "../../pageheader";
import smsServiceNew from "../../../api/reservePlanNew.service";

import rules from "../../../utils/rules";

export default {
  name: "purchase-quote-request",
  components: { pageheader },
  data() {
    return {
      rules: rules,
      valid: true,
      input: {},
      BirchCustomerUserID: "",
      BirchCustomerID: "",
      items: [],
      isSaveBtn: false,
      categorylist: [],
      departmentList: [],
      groupList: [],
      selectedItemList: [],
      itemsobj: {},
      selectCategory: "",
      selectDept: "",
      selectGroup: "",
      selectedItem: "",
      comments: "",
      isLoading: false,
      companyName: "",
      name: "",
      phone: "",
      email: "",
      selectModel: "",
      selectYear: "",
      selectHours: 1,
      storeP: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      stateList: [
        "AL",
        "AK",
        "AS",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "DC",
        "FL",
        "GA",
        "GU",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MH",
        "MA",
        "MI",
        "FM",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "MP",
        "OH",
        "OK",
        "OR",
        "PW",
        "PA",
        "PR",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "VI",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
      equipmentComment: "",
      deliveryRequired: "",
      storeList: [
        "Anacortes",
        "Bellingham",
        "Everett",
        "Mount Vernon",
        "Sitka, Alaska",
      ],
      deliveryType: [
        {
          type: "Delivery",
          value: "delivery",
        },
        {
          type: "In-store Pickup",
          value: "pickup",
        },
      ],
      masterItems: [],
      masterItemsLoading: false,
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.masterItems = JSON.parse(window.localStorage.getItem("masterItems"));
    this.input = utils.getInputContent("purchaseOrderRequest", this.roles);

    if (this.masterItems && this.masterItems.length > 0) {
      this.initialCalls();
    } else {
      this.getMasterItemsList();
    }
  },
  methods: {
    initialCalls() {
      this.getItemsList();
    },
    async getMasterItemsList() {
      this.masterItemsLoading = true;
      this.masterItems = [];
      try {
        let response = await smsServiceNew.getItemsList();
        if (response) {
          this.masterItems = response.data;
          await window.localStorage.setItem(
            "masterItems",
            JSON.stringify(response.data)
          );
        } else {
          this.masterItems = [];
          await window.localStorage.setItem("masterItems", JSON.stringify([]));
        }
        this.initialCalls();
        this.masterItemsLoading = false;
      } catch (err) {
        this.initialCalls();
        await window.localStorage.setItem("masterItems", JSON.stringify([]));
        this.masterItemsLoading = false;
        console.log(err);
      }
    },
    getItemsList() {
      this.isLoading = true;
      this.items = [];
      this.items = this.masterItems;
      this.itemsobj = this.items.filter(
        (e) => e.itemKey == this.$route.params.itemKey
      );
      this.categorylist = [];
      this.departmentList = [];
      this.categorylist = this.items.filter(
        (thing, i, arr) =>
          arr.findIndex((t) => t.categoryNm === thing.categoryNm) === i
      );
      this.categorylist = this.categorylist.sort((a, b) =>
        a.categoryNm.localeCompare(b.categoryNm)
      );
      this.departmentList = this.items.filter(
        (thing, i, arr) =>
          arr.findIndex((t) => t.departmentNm === thing.departmentNm) === i
      );
      this.departmentList = this.departmentList.sort((a, b) =>
        a.departmentNm.localeCompare(b.departmentNm)
      );

      this.groupList = this.items.filter(
        (thing, i, arr) =>
          arr.findIndex((t) => t.itemGroupNm === thing.itemGroupNm) === i
      );
      this.groupList = this.groupList.sort((a, b) =>
        a.itemGroupNm.localeCompare(b.itemGroupNm)
      );

      this.selectCategory = this.itemsobj[0].categoryNm;
      this.selectDept = String(this.itemsobj[0].departmentNm);
      this.selectGroup = this.itemsobj[0].itemGroupNm;
      this.selectedItem = this.itemsobj[0].itemNm;
      this.departmentList = this.departmentList.filter(
        (e) => e.categoryNm == this.selectCategory
      );
      this.groupList = this.groupList.filter(
        (e) => e.departmentNm == this.selectDept
      );
      this.selectedItemList = this.items.filter(
        (e) =>
          e.categoryNm == this.selectCategory &&
          e.departmentNm == this.selectDept &&
          e.itemGroupNm == this.selectGroup
      );
      this.isLoading = false;
    },

    catChange(selectCategory) {
      this.selectDept = "";
      this.selectGroup = "";
      this.selectedItem = "";
      this.departmentList = this.items.filter(
        (e) => e.categoryNm == selectCategory
      );
    },
    deptChange(selectDept) {
      this.selectGroup = "";
      this.selectedItem = "";

      this.groupList = this.items.filter((e) => e.departmentNm == selectDept);
    },
    grpChange(selectGroup) {
      this.selectedItem = "";
      this.selectedItemList = this.items.filter(
        (e) => e.itemGroupNm == selectGroup
      );
    },
    async submitPurchase() {
      let temp = this.items.filter((e) => e.itemNm == this.selectedItem);

      let itemkeyNew = temp[0].itemKey;
      let itemNmNew = temp[0].itemNm;
      let payload = {
        category: this.selectCategory,
        department: this.selectDept,
        group: this.selectGroup,
        itemKey: itemkeyNew,
        item: itemNmNew,
        model: this.selectModel,
        year: this.selectYear,
        approxHours: String(this.selectHours),
        equipmentComment: this.equipmentComment,
        company: this.companyName,
        name: this.name,
        phone: this.phone,
        email: this.email,
        comment: this.comments,
        deliveryRequired: this.deliveryRequired,
        Address1: this.address,
        City: this.city,
        state: this.state,
        zip: this.zip,
        store: this.storeP,
        customerUserEmail: this.email,
        customerUserPhone: this.phone,
        customerUserBirchContactEmail: this.email,
        birchCustomerUserID: Number(this.BirchCustomerUserID),
        birchContactID: Number(this.BirchCustomerUserID),
        birchCustomerID: Number(this.BirchCustomerID),
      };
      try {
        this.isSaveBtn = true;

        let response = await smsServiceNew.submitPurchase(payload);
        if (response && response.isSuccess) {
          this.isSaveBtn = false;
          this.$toast.success("Submitted Successfully");
        }
      } catch (err) {
        console.log(err);
      }
    },
    typeChange() {
      this.address = "";
      this.state = "";
      this.city = "";
      this.storeP = "";
      this.zip = "";
    },
  },
};
